export const getFileUrl = (currentUrl: string): string => {
  const parts = currentUrl.split('/').reverse();
  const key = parts.find((_) => !!_);
  if (key) {
    return `/download/${key}/`;
  }
  return '';
};
